export default __webpack_public_path__ + "static/raczynski-05b43c127176d097400ac163f1a365e8.jpg";